import React from 'react';
import { SketchPicker } from 'react-color';
import Dropdown from 'react-dropdown';
import { UpgradePlanCard } from '../../components';

let fontSize = [
  { value: '10', label: '10px' },
  { value: '12', label: '12px' },
  { value: '13', label: '13px' },
  { value: '14', label: '14px' },
  { value: '16', label: '16px' },
  { value: '18', label: '18px' },
  { value: '20', label: '20px' },
  { value: '22', label: '22px' },
  { value: '24', label: '24px' },
  { value: '26', label: '26px' },
  { value: '28', label: '28px' },
  { value: '30', label: '30px' },
  { value: '32', label: '32px' },
  { value: '34', label: '34px' },
  { value: '36', label: '36px' },
  { value: '38', label: '38px' },
  { value: '40', label: '40px' },
  { value: '42', label: '42px' },
  { value: '44', label: '44px' }
];

//for post card and popup card toggle
export const PostToggleCard = (props) => {
  const { className, ttl, fieldName, value, handleCnfChange } = props;
  return (
    <div className={`${'editor-field-list editor-toggle ' + className}`}>
      <label className="label-title">{ttl}</label>
      <div className="d-flex">
        <label className="switch">
          <input type="checkbox" checked={value} onChange={(e) => handleCnfChange(fieldName, e.target.checked)} />
          <span className="slider round"></span>
        </label>
      </div>
      {props.children}
    </div>
  );
};

export const SelectTemplateCard = ({ arrLylt, currLayoutId, updateLayoutById }) => {
  return (
    <div className="card card-editor card-template">
      <div className="card-editor-block">
        <label className="card-editor-title">Layouts</label>
        <div className="template-list">
          {
            arrLylt && arrLylt.map((val, key) => {
              return (
                <div className={val._id == currLayoutId ? 'theme-layout-item theme-block active' : 'theme-layout-item theme-block'} key={key} onClick={() => updateLayoutById(val._id)}>
                  <div className={val.ltn == 'avatar_slider' || val.ltn == 'single_h_slider' || val.ltn == 'auto_slider' ? 'theme-new-tag' : ''}>
                    <span className="theme-layout-name">{val.tn}</span>
                    <img src={val.iu} alt="theme" />
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div >
  );
};

export const CtaLableCard = ({ cnf, handleCnfChange, widgetType }) => {
  return (
    <div className="card card-editor card-template mt-15">
      <div className="card-editor-block card-editor-tgldflclose card-editor-rtrnvst">
        <label className="card-editor-title">CTA</label>
        <div className="editor-field-list card-editor-titletgl editor-toggle-fullwt">
          {cnf.tlsibtn != undefined &&
            <div className="width10x">
              <label className="label-title">Show CTA Label</label>
              <label className="switch">
                <input type="checkbox" checked={cnf.tlsibtn} onChange={(e) => handleCnfChange('tlsibtn', e.target.checked)} />
                <span className="slider round"></span>
              </label>
            </div>
          }
          {(cnf.tlsibtn == true || widgetType == 'job_board' || widgetType == 'tool_pricing') &&
            <div className="customize-list customize-cttimer-ctalabel width10x">
              {cnf.tlsbtntxt != undefined &&
                <div className="input-ctalabel input-ctalabel-dicsnt mb-4">
                  <label className="label-title">Label</label>
                  <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlsbtntxt} onChange={(e) => handleCnfChange('tlsbtntxt', e.target.value)} placeholder="CTA label"></input>
                </div>
              }
              {cnf.tlsbtnrdcturl != undefined &&
                <div className="input-ctalabel input-ctalabel-ctaurl mb-4">
                  <label className="label-title">URL</label>
                  <input className='editor-input-content editor-input-fullwidth' type="text" value={cnf.tlsbtnrdcturl} onChange={(e) => handleCnfChange('tlsbtnrdcturl', e.target.value)} placeholder="CTA URL"></input>
                </div>
              }
              {cnf.tlsbtnclksmtb != undefined &&
                <div className="labeltgl-ctalabel">
                  <label className="label-title">Open in same tab</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.tlsbtnclksmtb} onChange={(e) => handleCnfChange('tlsbtnclksmtb', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export const CustomWidthCard = ({ cnf, handleCnfChange, handleUpgradePlan }) => {
  return (
    <div className="card card-editor card-content-width mt-15">
      <div className="card-editor-block p-0">
        <div className='card-plan-div'>
          <label className="card-editor-title">Content-width</label>
          <UpgradePlanCard
            handleUpgradePlan={handleUpgradePlan}
          />
        </div>
        <div className="content-width-list">
          <PostToggleCard
            className={'editor-toggle-contentwt editor-toggle-fullwt'}
            ttl={'Auto height'}
            fieldName={'ihgtat'}
            value={cnf.ihgtat}
            handleCnfChange={handleCnfChange}>
            {cnf.ihgtat == false &&
              <div className="editor-rangesdr editor-rangesdr-contentwt editor-rangesdr-customwt">
                <label className="label-title">Custom height (in px)</label>
                <input className="editor-input-content editor-input-contenthgt" type="number" id="input-float" value={cnf.hght} onChange={(e) => handleCnfChange('hght', e.target.value)} />
              </div>
            }
          </PostToggleCard>
          <PostToggleCard
            className={'editor-toggle-contentwt editor-toggle-fullwt'}
            ttl={'Full width'}
            fieldName={'irspn'}
            value={cnf.irspn}
            handleCnfChange={handleCnfChange}>
            {cnf.irspn == false &&
              <div className="editor-rangesdr editor-rangesdr-contentwt editor-rangesdr-customwt">
                <label className="label-title">Custom width (in px)</label>
                <input className="editor-input-content editor-input-contentwth" type="number" id="input-float" value={cnf.wdt} onChange={(e) => handleCnfChange('wdt', e.target.value)} />
              </div>
            }
          </PostToggleCard>
        </div>
      </div>
    </div>
  );
};

export const CmnCustomizeCard = ({
  label,
  ddnValue,
  ddnField,
  handleCnfChange,
  handleColorPicker,
  colorPick,
  clrField,
  clrValue
}) => {
  return (
    <div className="editor-field-list editor-toggle customize-dropdown customize-isaction">
      <label className="label-title">{label}</label>
      <div className="d-flex editor-cardcmn-fntclr">
        <div className="editor-dropdown editor-dropdown-sm  wg-dd-fntclr mr-3 mb-0">
          <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontSize} value={ddnValue ? ddnValue.toString() : ddnValue} onChange={(e) => handleCnfChange(ddnField, e.value)} />
        </div>
        <div className="colorpicker-box" id="color_code">
          <div className="colorpicker" onClick={() => handleColorPicker(clrField)} style={{ background: clrValue }}>
            <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
              <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
              <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
              <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
            </svg>
          </div>
          {
            colorPick == clrField ?
              <div className="colorPickPopover">
                <SketchPicker color={clrValue} onChange={(e) => handleCnfChange(clrField, e.rgb, 'rgb')} />
              </div>
              : null
          }
        </div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Widget/CustomizeCard.js